import { round } from 'lodash-es';
import type { MapboxIMap } from '..';

const precision = 5; // up to ~1 meter precision

export const getViewportBounds: MapboxIMap['getViewportBounds'] = function (
  this: MapboxIMap
) {
  const bounds = this._native.getBounds();
  return [
    round(bounds.getWest(), precision),
    round(bounds.getSouth(), precision),
    round(bounds.getEast(), precision),
    round(bounds.getNorth(), precision),
  ];
};
